module.exports = __webpack_public_path__ + "static/media/message-icon-2.30c18c7a.svg";